const VIZ_CONFIGS = {
    chart: {
        'General': {
            'Chart Type': {
                value: 'bar',
                rules: [],
                items: [{
                        icon: '',
                        value: 'bar',
                    }, {
                        icon: '',
                        value: 'line',
                    }, {
                        icon: '',
                        value: 'radar',
                    }, {
                        icon: '',
                        value: 'area',
                    }, {
                        icon: '',
                        value: 'pie',
                    }, {
                        icon: '',
                        value: 'donut',
                    }, {
                        icon: '',
                        value: 'scatter',
                    },
                    // Bubble type is kinda complex to manipulate
                    // {
                    //     icon: '',
                    //     value: 'bubble'
                    // },
                    {
                        icon: '',
                        value: 'heatmap',
                    }, {
                        icon: '',
                        value: 'box',
                    },
                ],
                type: 'Select',
            },
            'X Column': {
                clearable: false,
                multiple: false,
                rules: [(v) => { return !!v || 'You have to specify an X Column' }],
                type: 'Column',
                value: '',
            },
            'Y Columns': {
                clearable: false,
                multiple: true,
                rules: [(v) => { return v.length > 0 || 'You have to specify at least one Y Column' }],
                type: 'Column',
                value: '',
            },
            // 'Group by': {
            //     clearable: true,
            //     type: 'Column',
            //     value: '',
            // },
            'Inverse X Column and Y Column': {
                icon: 'mdi-swap-horizontal',
                type: 'Button',
                atClick: (config) => {
                    if (config) {
                        let a = _.clone(config['General']['X Column'].value)
                        let b = _.clone(config['General']['Y Columns'].value[0])
                        config['General']['X Column'].value = b
                        config['General']['Y Columns'].value = [a]
                    }
                },
            },
        },
    },
    table: {
        'Columns': {
            'Column Parameters': {
                type: 'TableColumns',
                columns: {},
            },
        },
        'Grid': {
            'Items per page': {
                value: 5,
                items: [5, 10, 15, 20, 25, 50, 100, 150, 200, 250],
                max: 'rows',
                type: 'Select',
            },
        },
    },
    counter: {
        'General': {
            'Counter Label': {
                value: 'Counter label',
                placeholder: 'Counter',
                counter: 50,
                rules: [v => !!v || 'You have to specify a label', v => v.length <= 50 || 'Max characters is 50'],
                type: 'String',
            },
            'Counter Value Column Name': {
                value: '',
                type: 'Column',
                isDisabledBy: 'Count Rows',
            },
            'Counter Value Row Number': {
                value: 1,
                type: 'Number',
                min: 1,
                max: 'rows',
                isDisabledBy: 'Count Rows',

            },
            'Count Rows': {
                value: false,
                type: 'Checkbox',
            },
        },
        'Format': {
            'Formatting Decimal Place': {

                value: 2,
                min: 0,
                max: 15,
                type: 'Number',
            },
            'Formatting Decimal Character': {

                value: '.',
                type: 'String',
            },
            'Formatting Thousands Separator': {

                value: ',',
                min: 0,
                max: 25,
                type: 'String',
            },
            'Formatting String Prefix': {

                value: '',
                min: 0,
                max: 25,
                type: 'String',
            },
            'Formatting String Suffix': {

                value: '',
                min: 0,
                max: 25,
                type: 'String',
            },
        },
    },
}
export {
    VIZ_CONFIGS,
}